import React from "react";
import PenIcon from "../../Assets/Icons/panIcon.svg";
import CloseIcon from "../../Assets/Icons/closeIcon.svg";
import PreviousImg from '../../Assets/TeamProfile.png'

export default function PreviousProject(props) {
  return (
    <div className="w-full border-[1px] rounded-[12px] border-[#E5E7EB] py-4 px-4 bg-white">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2">
          <img className="w-[3.1rem] h-[3.1rem] rounded-[5px]" src={PreviousImg} />
          <div className="flex flex-col gap-[1px]">
            <p className="text-[1.2rem] font-[500] text-[#111928]">
              {props.projecttitle}
            </p>
            <p className="text-[1rem] text-[#6B7280]">{props.location}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
            <img src={props.penicon} />
            <img src={props.closeicon} />
        </div>
      </div>
      <div>
        <p className="text-[0.94rem] text-[#6B7280] mt-3">{props.desc}</p>
      </div>
    </div>
  );
}
